<template>
  <div class="right">
    <div class="right-1" v-if="detail.userType==1 || detail.userType==3">
      <div class="right-title">{{$t('global.频道简介')}}</div>
      <div class="right-subject-title">{{detail.title}}</div>
      <div class="right-author">
        <img
          class="right-author-avatar"
          @click="goToUser(detail.userId)"
          :src="detail.avatar | imageUrl('/static/profile_img_default.png',40,40)"
        />
        <span class="right-author-name" @click="goToUser(detail.userId)">{{detail.nickName}}</span>
        <span class="right-author-time">{{detail.date}}</span>
      </div>
      <div class="right-content">
        <div v-if="isCollapse" class="right-content-content">{{detail.introduction | subStr(100)}}</div>
        <div v-if="!isCollapse" class="right-content-content" v-html="introductionHtml"></div>
        <span v-if="detail.introduction.length>100" @click="collapse" class="right-collapse">
          {{collapseText}}
          <span class="el-icon-caret-bottom"></span>
        </span>
      </div>
      <button class="right-1-btn" v-on:click="Join()">{{$t('global.关注该频道')}}</button>
    </div>
    <div class="right-1" v-if="detail.userType==2">
      <div class="right-title">{{$t('global.频道信息')}}</div>
      <div class="right-subject-title">{{detail.title}}</div>
      <div
        class="right-subject-content"
      >{{$t('global.频道内共有')}}{{detail.videoCount || 0}}{{$t('global.个视频')}}，{{$t('global.其中组员推荐的视频有')}}{{detail.recommendVideoCount}}{{$t('global.个')}}</div>
      <img class="right-subject-thumb" :src="detail.thumb | imageUrl('',660,376)" />
    </div>
    <div class="right-1" v-if="Number(detail.userType) > 1 && Number(detail.userType) != 3">
      <div class="right-title">{{$t('global.频道简介')}}</div>
      <div class="right-subject-title">{{detail.title}}</div>
      <div class="right-author">
        <img
          class="right-author-avatar"
          @click="goToUser(detail.userId)"
          :src="detail.avatar | imageUrl('/static/profile_img_default.png',40,40)"
        />
        <span class="right-author-name" @click="goToUser(detail.userId)">{{detail.nickName}}</span>
        <span class="right-author-time">{{detail.date}}</span>
      </div>
      <div class="right-content">
        <div v-if="isCollapse" class="right-content-content">{{detail.introduction | subStr(100)}}</div>
        <div v-if="!isCollapse" class="right-content-content" v-html="introductionHtml"></div>
        <span v-if="detail.introduction.length>100" @click="collapse" class="right-collapse">
          {{collapseText}}
          <span class="el-icon-caret-bottom"></span>
        </span>
      </div>
      <button
        v-if="detail.userType - 4 === 0 "
        class="right-1-btn"
        @click="GotoUrl(`/subject/edit/${detail.id}/step1`)"
      >{{$t('global.设置频道')}}</button>
    </div>
    <div class="right-2">
      <div class="right-title">{{$t('global.频道信息')}}</div>
      <div
        class="right-sum"
        :class="{active: activeShow === 1}"
        v-on:click="GotoUrl('/subjectdetail/'+detail.id)"
      >
        {{$t('global.本频道共有')}}{{detail.videoCount || 0}}{{$t('global.个视频')}}
        <span
          class="el-icon-caret-right"
        ></span>
      </div>
      <div
        class="right-sum"
        :class="{active: activeShow === 2}"
        v-on:click="GotoUrl('/subjectmember?id='+detail.id)"
      >
        {{$t('global.本频道共有')}}{{detail.memberCount}}{{$t('global.个成员')}}
        <span
          class="el-icon-caret-right"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SubjectRight",
  props: {
    detail: Object,
    type: String
  },
  data() {
    return {
      isCollapse: true,
      collapseText: this.$t("global.展开"),
      introductionHtml: ""
    };
  },
  computed: {
    activeShow() {
      if (this.$route.path === "/subjectdetail") {
        return 1;
      } else if (this.$route.path === "/subjectmember") {
        return 2;
      }
    }
  },
  updated() {
    let introduction = this.detail.introduction;
    if (introduction) {
      this.introductionHtml = this.passage(introduction);
    }
  },
  methods: {
    goToUser(userId) {
      this.$router.push(`/peopleCenter/${userId}`);
    },
    passage(val) {
      let arr = val.split("\n");
      let str = "";
      for (let i = 0; i < arr.length; i++) {
        const el = arr[i];
        str += el + "<br/>";
      }
      return str;
    },
    collapse() {
      this.isCollapse = !this.isCollapse;
      this.collapseText = this.isCollapse
        ? this.$t("global.展开")
        : this.$t("global.收起");
    },
    GotoUrl(url) {
      this.$router.push(url);
    },
    Join() {
      var $this = this;
      if (this.detail.userType == 1) {
        this.GotoUrl(
          "/login?redirecturl=" +
            window.location.pathname +
            window.location.search
        );
      } else if (this.detail.userType == 3) {
        this.$http
          .post("/api/u/topic/join", {
            topicId: this.detail.id
          })
          .then(function(response) {
            $this.$message({
              message: $this.$t("global.加入成功"),
              type: "success",
              duration: 2000
            });
          });
      }
    }
  }
};
</script>

<style scoped>
.right {
  width: 3.8rem;
  margin-left: 0.2rem;
  float: left;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.right-1 {
  margin-top: 0.4rem;
  background-color: #fff;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  padding: 0.3rem 0.25rem 0.4rem;
}

.right-subject-thumb {
  width: 3.3rem;
  height: 1.88rem;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  display: block;
  margin-top: 0.25rem;
}

.right-title {
  font-size: 0.18rem;
  color: #333333;
  font-weight: bold;
  margin-left: -0.25rem;
  padding-left: 0.25rem;
  position: relative;
  margin-bottom: 0.25rem;
}

.right-title:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0.03rem;
  display: block;
  width: 0.06rem;
  height: 0.19rem;
  background-color: #0161ff;
  -webkit-border-radius: 0.03rem;
  -moz-border-radius: 0.03rem;
  border-radius: 0.03rem;
  margin-bottom: 0.3rem;
}

.right-subject-title {
  font-size: 0.22rem;
  color: #333;
  font-weight: bold;
  text-overflow: ellipsis; /*$t('global.只是起到注解作用')*/
  white-space: nowrap; /*$t('global.不让文本换行')*/
  overflow: hidden; /*$t('global.超出的部分显示')...*/
}

.right-count {
  font-size: 0.14rem;
  color: #999999;
  margin: 0.07rem 0 0.12rem;
}

.right-cat {
  font-size: 0.16rem;
  color: #777777;
  margin-bottom: 0.19rem;
}
.right-cat span {
  padding-right: 10px;
}
.right-author {
  line-height: 0.5rem;
  height: 0.5rem;
  margin-top: 0.3rem;
  margin-bottom: 0.3rem;
}

.right-author-avatar {
  cursor: pointer;
  width: 0.5rem;
  height: 0.5rem;
  display: inline-block;
  vertical-align: middle;
  margin-right: 0.2rem;
  float: left;
  border-radius: 50%;
}

.right-author-name {
  cursor: pointer;
  width: 1.5rem;
  display: inline-block;
  font-size: 0.2rem;
  color: #333333;
  float: left;
  text-overflow: ellipsis; /*$t('global.只是起到注解作用')*/
  white-space: nowrap; /*$t('global.不让文本换行')*/
  overflow: hidden; /*$t('global.超出的部分显示')...*/
}

.right-author-time {
  font-size: 0.18rem;
  color: #777;
  float: right;
}

.right-content {
  clear: both;
  font-size: 0.16rem;
  color: #777777;
  line-height: 0.3rem;
  position: relative;
}

.right-content-content {
  min-height: 0.2rem;
  display: block;
  word-break: break-word;
}

.right-collapse {
  position: absolute;
  right: 0;
  bottom: -0.2rem;
  font-size: 0.16rem;
  color: #0060ff;
  cursor: pointer;
}

.right-1-btn {
  width: 1.8rem;
  height: 0.4rem;
  line-height: 0.4rem;
  padding: 0;
  display: block;
  -webkit-border-radius: 0.2rem;
  -moz-border-radius: 0.2rem;
  border-radius: 0.2rem;
  border: none;
  background-color: #0060ff;
  color: #fff;
  font-size: 0.16rem;
  font-weight: bold;
  text-align: center;
  margin: 0.2rem auto 0;
}

.right-2 {
  margin-top: 0.2rem;
  background-color: #fff;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  padding: 0.3rem 0.25rem 0.2rem;
}

.right-sum {
  font-size: 0.2rem;
  font-weight: bold;
  color: #333333;
  line-height: 0.6rem;
  position: relative;
  cursor: pointer;
  margin: 0 -0.25rem;
  padding: 0 0.25rem;
}

.right-sum span {
  position: absolute;
  right: 0;
  top: 0.2rem;
}

.right-sum.active {
  background-color: #0060ff;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/SubjectRight.vue